let n = "english";
const i = "english", s = "english-lbs", F = "metric";
function te() {
  n = i;
}
function re() {
  n = s;
}
function ie() {
  n = F;
}
function o(e, t) {
  var r, u = document.getElementsByClassName(e);
  for (r = 0; r < u.length; r += 1)
    u.item(r).innerHTML = t;
}
function x() {
  n === i ? (o("units-force", "kips"), o("units-force-per-length", "kips/in"), o("units-pressure", "ksi"), o("units-moment", "kip-in"), o("units-length", "in")) : n === s ? (o("units-force", "lbs"), o("units-force-per-length", "lbs/in"), o("units-pressure", "ksi"), o("units-moment", "lb-in"), o("units-length", "in")) : (o("units-force", "kN"), o("units-force-per-length", "kN/m"), o("units-pressure", "kPa"), o("units-moment", "kN-m"), o("units-length", "m")), document.dispatchEvent(new CustomEvent("units-changed"));
}
function se() {
  document.getElementById("units-selector").innerHTML = "English Units (kips)", n = i, x();
}
function oe() {
  document.getElementById("units-selector").innerHTML = "English Units (lbs)", n = s, x();
}
function ue() {
  document.getElementById("units-selector").innerHTML = "Metric Units (kN)", n = F, x();
}
var l = 2, g = 2, L = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(\"|in|inch|inches)(\s{0,})$/), k = new RegExp(/(\"|in|inch|inches)/), U = new RegExp(/^(\s{0,})(-{0,1})\d*\/\d*(\s{0,1})(\"|in|inch|inches)(\s{0,})$/), M = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(\'|ft|feet)(\s{0,})$/), b = new RegExp(/(\'|ft|feet)/), $ = new RegExp(/^(\s{0,})(-{0,1})\d*(\s{0,1})(\'|ft|feet)(\s{0,})\d*((\s{0,})|(\s{0,1})(\"|in|inch|inches)(\s{0,}))$/), P = new RegExp(/^(\s{0,})(-{0,1})\d*(\s{0,1})(\'|ft|feet)(\s{0,})\d*(\s{0,1})\d*\/\d*(\s{0,1})(\"|in|inch|inches)(\s{0,})$/), I = new RegExp(/^(\s{0,})(-{0,1})\d*(\s{0,1})$/), S = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})$/), T = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(m|meter|meters)(\s{0,})$/), B = new RegExp(/(m|meter|meters)/), C = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})((cm)|(centimeter)|(centimeters))(\s{0,})$/), H = new RegExp(/(cm|centimeter|centimeters)/), y = new RegExp(/^(\s{0,})(-{0,1})\d*(|\.\d*)(\s{0,1})(mm|millimeter|millimeters)(\s{0,})$/), K = new RegExp(/(mm|millimeter|millimeters)/);
function E(e) {
  var t = e.split(k);
  if (t.length <= 0 || isNaN(t[0]))
    throw "Error Parsing Inches: " + e;
  return Number(t[0]);
}
function v(e) {
  var t = e.split(k);
  if (t.length > 0 && (t = t[0].split(/\//), t.length > 1)) {
    var r = t[0], u = E(t[1]);
    if (!isNaN(r) && !isNaN(u))
      return Number(r) / Number(u);
  }
  throw "Error Parsing Inch Fraction: " + e;
}
function D(e) {
  var t = e.split(b);
  if (t.length <= 0 || isNaN(t[0]))
    throw "Error Parsing Feet: " + e;
  return Number(t[0] * 12);
}
function ce(e, t) {
  if (e = e.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"'), e.match(I) || e.match(S))
    return t && (t === "inches" || t === "in") ? Number(e) : Number(e) * 12;
  if (e.match(L))
    return E(e);
  if (e.match(U))
    return v(e);
  if (e.match(M))
    return D(e);
  if (e.match($)) {
    var r = e.split(b);
    try {
      var u = Number(r[0]), m = E(r[2]);
      return u * 12 + m;
    } catch (a) {
      return console.log(a), 0;
    }
  }
  if (e.match(P)) {
    const a = e.split(b), p = Number(a[0]);
    let c = a[2].split(" ");
    c.length < 3 && c.unshift(" ");
    const w = Number(c[1]) || 0, h = v(c[2]);
    return p * 12 + w + h;
  }
  if (e.match(T)) {
    var r = e.split(B), N = Number(r[0]);
    return Math.round(N * 39.370078 * 1e4) / 1e4;
  }
  if (e.match(C)) {
    var r = e.split(H), f = Number(r[0]);
    return f * 0.39370078;
  }
  if (e.match(y)) {
    var r = e.split(K), d = Number(r[0]);
    return d * 0.039370078;
  }
  return NaN;
}
function G(e) {
  return Number(e).toFixed(2) + " in";
}
function W(e, t) {
  const r = Math.floor(e / 12);
  let u = e % 12;
  const m = Math.floor(u), N = u - m;
  let f = "";
  if (N !== 0) {
    const d = (w, h) => h ? d(h, w % h) : w, p = Math.round(N * 16), c = d(p, 16);
    f = ` ${p / c}/${16 / c}`;
  }
  return m === 0 && f === "" ? t ? `${r}&#39;` : `${r}'` : t ? `${r}&#39; ${m}${f}&#34;` : `${r}' ${m}${f}"`;
}
function _(e, t = !1) {
  return W(e, t);
}
function j(e) {
  return Number(e / 39.370078).toFixed(4) + " m";
}
function q(e) {
  return Number(e / 39.370078 * 1e3).toFixed(2) + " mm";
}
function le(e, t = !1) {
  return n === i || n === s ? _(e, t) : j(e);
}
function me() {
  return n === i || n === s ? "in" : "mm";
}
function fe(e) {
  return n === i || n === s ? e : e * 25.4;
}
function ae(e) {
  return n === i || n === s ? e : e * 0.0254;
}
function he(e) {
  return n === i || n === s ? G(e) : q(e);
}
function R(e) {
  return Number(e).toFixed(l);
}
function z(e) {
  return (Number(e) * 4.44822).toFixed(l);
}
function A(e) {
  return (Number(e) * 1e-3).toFixed(l);
}
function J(e) {
  return (Number(e) * 444822e-8).toFixed(l);
}
function ge(e) {
  return n === i || n === s ? R(e) : z(e);
}
function Ne(e) {
  return n === i ? A(e) : n === s ? R(e) : J(e);
}
function de() {
  return n === i || n === s ? "lbs" : "N";
}
function pe() {
  return n === i ? "kips" : n === s ? "lbs" : "kN";
}
function O(e) {
  return Number(Number(e)).toFixed(g);
}
function Q(e) {
  return Number(Number(e) / 12).toFixed(g);
}
function V(e) {
  return Number(Number(e) / 1e3 / 12).toFixed(g);
}
function X(e) {
  return Number(e / 8850.7457673787 * 1e3).toFixed(g);
}
function Y(e) {
  return Number(e / 8850.7457673787).toFixed(g);
}
function we(e) {
  return n === i || n === s ? O(e) : X(e);
}
function be(e) {
  return n === i ? V(e) : n === s ? Q(e) : Y(e);
}
function Ee() {
  return n === i || n === s ? "lb-in" : "N-m";
}
function xe() {
  return n === i ? "kip-ft" : n === s ? "lb-ft" : "kN-m";
}
function Z(e) {
  return (Number(e) * 12).toFixed(l);
}
function ee(e) {
  return (Number(e) / 1e3 * 12).toFixed(l);
}
function ne(e) {
  return (Number(e) / 1e3 * 39.370078 / 0.224808943).toFixed(l);
}
function ve(e) {
  return n === i ? ee(e) : n === s ? Z(e) : ne(e);
}
function Fe() {
  return n === i ? "k/ft" : n === s ? "lb/ft" : "kN/m";
}
export {
  Fe as bigLinearForceUnit,
  xe as bigMomentUnit,
  pe as bigPointLoadUnit,
  n as gUnits,
  oe as onEnglishLbsUnitsClicked,
  se as onEnglishUnitsClicked,
  ue as onMetricUnitsClicked,
  re as setEnglishLbsUnits,
  te as setEnglishUnits,
  ie as setMetricUnits,
  ve as showBigLinearForce,
  be as showBigMoment,
  Ne as showBigPointLoad,
  ae as showDistanceLength,
  _ as showFeetInches,
  le as showLengthWithUnits,
  fe as showSmallLength,
  he as showSmallLengthWithUnits,
  we as showSmallMoment,
  ge as showSmallPointLoad,
  me as smallLengthUnit,
  Ee as smallMomentUnit,
  de as smallPointLoadUnit,
  ce as wsParseLength
};
